import AdminLayout from "../components/AdminLayout";
import { useApp } from "../context/AppContext";

const CHIP = { Pending:{bg:"#fef3e2",c:"#d97706",icon:"⏳"}, Approved:{bg:"#dcfce7",c:"#16a34a",icon:"✅"}, Rejected:{bg:"#fee2e2",c:"#dc2626",icon:"❌"} };
const NAV_KEY = { "Air Tickets":"air-tickets", "Hotels":"hotels", "Visas":"visas" };

export default function AdminService({ navigate, service, icon }) {
  const { applications, updateStatus } = useApp();
  const apps = applications.filter(a => a.service_type?.includes(service === "Air Tickets" ? "Air" : service === "Hotels" ? "Hotel" : "Visa"));
  const stats = { total:apps.length, pending:apps.filter(a=>a.status==="Pending").length, approved:apps.filter(a=>a.status==="Approved").length };

  return (
    <AdminLayout navigate={navigate} active={NAV_KEY[service]} title={`${icon} ${service}`}>
      {/* MINI STATS */}
      <div className="rgrid-3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
        {[["Total "+service,stats.total,"linear-gradient(90deg,#4a7fb5,#8a9fc4)"],["Pending",stats.pending,"linear-gradient(90deg,#f59e0b,#fbbf24)"],["Approved",stats.approved,"linear-gradient(90deg,#22c55e,#4ade80)"]].map(([l,v,col])=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"18px 20px",border:"1px solid #e4e9f0",position:"relative",overflow:"hidden",textAlign:"center"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:col}}/>
            <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:36,fontWeight:700,color:"#0d1f3c"}}>{v}</div>
            <div style={{fontSize:11,letterSpacing:"1.5px",textTransform:"uppercase",color:"#6b7a90",marginTop:4}}>{l}</div>
          </div>
        ))}
      </div>

      {/* TABLE */}
      <div style={{background:"#fff",borderRadius:16,border:"1px solid #e4e9f0",overflow:"hidden"}}>
        <div style={{padding:"18px 24px",borderBottom:"1px solid #eaeef5",background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
          <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:600,color:"#0d1f3c"}}>{icon} {service} — All Records</h2>
        </div>
        {apps.length > 0 ? (
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead style={{background:"#f6f8fc"}}>
                <tr>
                  {["App ID","Applicant","Service","Destination","Travel Date","Agent","Status","Actions"].map(h=>(
                    <th key={h} style={{padding:"12px 14px",textAlign:"left",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600,borderBottom:"1px solid #eaeef5"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {apps.map(app=>(
                  <tr key={app.id} style={{borderBottom:"1px solid #f0f3f9"}}>
                    <td style={{padding:"13px 14px"}}><strong style={{fontFamily:"'Cormorant Garamond',serif",color:"#0d1f3c",fontSize:13}}>{app.id}</strong></td>
                    <td style={{padding:"13px 14px"}}><strong style={{fontSize:13}}>{app.full_name}</strong><br/><span style={{fontSize:11,color:"#6b7a90"}}>{app.email}</span></td>
                    <td style={{padding:"13px 14px"}}><span style={{background:"#e0ecff",color:"#2563eb",padding:"3px 9px",borderRadius:6,fontSize:11,fontWeight:500}}>{app.service_type}</span></td>
                    <td style={{padding:"13px 14px",fontSize:13}}>{app.destination}</td>
                    <td style={{padding:"13px 14px",fontSize:13}}>{app.travel_date}</td>
                    <td style={{padding:"13px 14px",fontSize:13}}>{app.agent_name}</td>
                    <td style={{padding:"13px 14px"}}>
                      <span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:CHIP[app.status]?.bg,color:CHIP[app.status]?.c}}>
                        {CHIP[app.status]?.icon} {app.status}
                      </span>
                    </td>
                    <td style={{padding:"13px 14px"}}>
                      <div style={{display:"flex",gap:5}}>
                        <button onClick={()=>navigate("view",{app_id:app.id})} style={{padding:"5px 10px",borderRadius:7,fontSize:11,fontWeight:600,background:"#e0ecff",color:"#2563eb",border:"none",cursor:"pointer"}}>View</button>
                        {app.status==="Pending"&&<>
                          <button onClick={()=>updateStatus(app.id,"Approved")} style={{padding:"5px 10px",borderRadius:7,fontSize:11,fontWeight:600,background:"#dcfce7",color:"#16a34a",border:"none",cursor:"pointer"}}>✓</button>
                          <button onClick={()=>updateStatus(app.id,"Rejected")} style={{padding:"5px 10px",borderRadius:7,fontSize:11,fontWeight:600,background:"#fee2e2",color:"#dc2626",border:"none",cursor:"pointer"}}>✗</button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{padding:60,textAlign:"center"}}>
            <div style={{fontSize:44,marginBottom:12}}>{icon}</div>
            <p style={{fontSize:13,color:"#6b7a90"}}>No {service} applications yet.</p>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
